import React from "react";
import cn from "classnames";
import styles from "./Profile.module.sass";
import { useAuth } from "../../../contexts/AuthContext";
import LetterAvatar from "../../../components/LetterAvatar";

// Fonction pour formater la date (similaire à celle utilisée dans StudentDetail)
const formatDate = (dateString) => {
  if (!dateString) return "Non définie";
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const Profile = ({ student }) => {
  const { currentUser } = useAuth();
  
  // Si aucun étudiant n'est fourni, afficher un message de chargement
  if (!student) {
    return <div className={styles.profile}>Chargement des données...</div>;
  }
  
  // Débogage des données de formation
  console.log('Données de formation dans Profile:', {
    formation: student.formation,
    expand: student.expand,
    hasFormationExpand: !!student.expand?.formation,
    formationKeys: student.expand?.formation ? Object.keys(student.expand.formation) : [],
    qualification_title: student.expand?.formation?.qualification_title
  });

  return (
    <div className={styles.profile}>
      <div className={styles.details}>
        <div className={styles.avatar}>
          <LetterAvatar firstName={student?.first_name} lastName={student?.last_name} size={80}/>
        </div>
        <div className={styles.wrap}>
          <div className={cn("h4", styles.man)}>{`${student?.first_name} ${student?.last_name}`}</div>
          <div className={styles.login}>
            {student.expand?.formation?.exact_title_of_qualification || 
             student.expand?.formation?.title || 
             (student.formation ? 'Formation associée' : 'Aucune formation')}
          </div>
        </div>
      </div>
      
      <div className={styles.statusInfo}>
        <div className={styles.statusContainer}>
          <div className={styles.statusGroup}>
            <div className={styles.login}>Statut</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              student.status === 'Inscrit' ? 'status-green-dark' : 'status-red-dark'
            )}>
              {student.status || 'Non défini'}
            </div>
          </div>

          {student.file_status !== 'Complet' && (
            <div className={styles.statusGroup}>
              <div className={styles.login}>Statut du dossier</div>
              <div className={cn(
                styles.statusBadge,
                'status-type',
                'status-red-dark'
              )}>
                {student.file_status || 'Non défini'}
              </div>
            </div>
          )}

          <div className={styles.statusGroup}>
            <div className={styles.login}>Date d'inscription</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              'status-blue-dark'
            )}>
              {formatDate(student.inscription_at)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
